module.exports = __webpack_public_path__ + "fonts/memnYaGs126MiZpBA-UFUKW-U9hlIqOjjg.c0c81864.woff2";